var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroundwater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_1155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9896 0H11.0104C4.9295 0 0 5.01305 0 11.197V48.803C0 54.9869 4.9295 60 11.0104 60H47.9896C54.0705 60 59 54.9869 59 48.803V11.197C59 5.01305 54.0705 0 47.9896 0Z",
    fill: "#FB7962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9285 37.2008C36.9285 41.3731 33.6032 44.7548 29.5004 44.7548C25.3976 44.7548 22.0723 41.3731 22.0723 37.2008C22.0723 35.7879 22.4535 34.4617 23.1255 33.3294L29.5004 21.751L35.8752 33.3294C36.5473 34.4617 36.9285 35.7879 36.9285 37.2008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8711 16.564H17.1275C15.5361 16.564 14.2461 15.2522 14.2461 13.6338C14.2461 12.0155 15.5361 10.7036 17.1275 10.7036H41.8711C43.4624 10.7036 44.7524 12.0155 44.7524 13.6338C44.7524 15.2522 43.4624 16.564 41.8711 16.564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_1155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundwater);
export default __webpack_public_path__ + "static/media/groundwater.0ec767f3b1c25cb2e5606a7a95a85d9a.svg";
export { ForwardRef as ReactComponent };